"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var WindowStateEnum_1 = require("./WindowStateEnum");
/**
 * Window search index designed to search windows corresponding to a query with common attributes and free text field.
 *
 * @author Radek Beran
 */


var WindowSearchIndex =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowSearchIndex, _DomainObject_1$Domai);

  /**
   * Creates new search index.
   *
   * @param id id of window
   * @param from start date - first moment of window validity
   * @param to end date - last moment of window validity (inclusive)
   * @param texts window externalId and normalized window name, reserved also for other possible texts
   * @param portfolio - id of level 4 category of products (CM category)
   * @param themeId
   * @param typeId
   * @param wfState state of workflow
   * @param pId promotion id
   * @param pTexts promotion external id and normalized name, reserved also for other possible promotion texts
   * @param pFrom start of promotion action
   * @param pTo end of promotion action
   * @param pStore defines store specification for filtering purposes
   * @param prTexts product external ids and normalized names, reserved also for other possible product texts
   * @param prCount product count
   * @param prIds product ids
   */
  function WindowSearchIndex( // Window attributes:
  id, from, to, texts, portfolio, themeId, typeId, wfState, // Promotion attributes:
  pId, pTexts, pFrom, pTo, pStore, // Product attributes:
  prTexts, prCount, prIds) {
    var _this;

    _classCallCheck(this, WindowSearchIndex);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowSearchIndex).call(this));
    _this.id = id;
    _this.from = from;
    _this.to = to;
    _this.texts = texts;
    _this.portfolio = portfolio;
    _this.themeId = themeId;
    _this.typeId = typeId;
    _this.wfState = wfState;
    _this.pId = pId;
    _this.pTexts = pTexts;
    _this.pFrom = pFrom;
    _this.pTo = pTo;
    _this.pStore = pStore;
    _this.prTexts = prTexts;
    _this.prCount = prCount;
    _this.prIds = prIds;
    return _this;
  }

  return WindowSearchIndex;
}(DomainObject_1.DomainObject);

exports.WindowSearchIndex = WindowSearchIndex;

WindowSearchIndex.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowSearchIndex.name);
  return {
    id: builder.id('id'),
    from: builder.date('from', DateParser_1.DateParser.ISO_PATTERN),
    to: builder.date('to', DateParser_1.DateParser.ISO_PATTERN),
    texts: builder.listOf(builder.str('texts')),
    portfolio: builder.str('portfolio'),
    themeId: builder.opt(builder.lookup('themeId', CodebookLookupSequence_1.CodebookLookupSequence.Theme)),
    typeId: builder.lookup('typeId', CodebookLookupSequence_1.CodebookLookupSequence.WindowTypes),
    wfState: builder.opt(builder.senum('wfState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    pId: builder.str('pId'),
    pTexts: builder.listOf(builder.str('pTexts')),
    pFrom: builder.date('pFrom', DateParser_1.DateParser.ISO_PATTERN),
    pTo: builder.date('pTo', DateParser_1.DateParser.ISO_PATTERN),
    pStore: builder.senum('pStore', StoreSpecificationEnum_1.StoreSpecificationEnum, CodebookLookupSequence_1.CodebookLookupSequence.StoreSpecification),
    prTexts: builder.listOf(builder.str('prTexts')),
    prCount: builder.opt(builder.num('prCount')),
    prIds: builder.listOf(builder.str('prIds'))
  };
}();